import styled from 'styled-components'
import { Nav, Image } from 'react-bootstrap'

export const Logo = styled(Image)`
  width: 100%;
  max-width: 9.375rem;
  height: auto;
  max-height: 3.75rem;
  cursor: pointer;
`

export const HeaderLink = styled(Nav.Link)`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1rem;
  text-decoration: none;
  color: var(--grey);
  margin-inline: 2rem;
  cursor: pointer;
  &:hover {
    color: var(--primary);
  }

  @media screen and (max-width: 992px) {
    margin-inline: 0;
  }
`

export const LinksWrapper = styled.div`
  display: flex;
  padding: 0 16px;
  height: 32px;
  border-radius: 4px;
  background: #F7941E;
  align-items: center;
  @media screen and (max-width: 992px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
`

export const LoginLink = styled.a`
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1rem;
  text-decoration: none;
  color: white;
  margin-inline: 1rem;
  margin-top: 0;
  cursor: pointer;

  &:hover {
    color: white;
  }

  @media screen and (max-width: 992px) {
    margin-inline: 0;
    margin-right: 1rem;
  }
`
